module.exports = __webpack_public_path__ + "static/media/affordable-catering-hero.68d452fc.jpg";